export default function getUserInitials(user: string) {
  return user
    ?.split(" ")
    ?.map((name) => name[0])
    .join("");
}
